import React, { useEffect, useRef, useState } from "react";
import { Form, Button, Card, Alert, InputGroup } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import "./style/Admin.css";

export default function AdminLogin() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { adminLogin, currentUser, logout } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  document.title ='Admin Login - Hentian Komuniti';

  async function handleSubmit(e) {
    e.preventDefault();
    console.log("Admin Login");
    try {
      const user = await adminLogin(
        emailRef.current.value,
        passwordRef.current.value
      );
      console.log("Post Login: ", user);
      setLoading(false);
      navigate("/admin/dashboard");
    } catch (error) {
      setLoading(false);
      setError("Failed to login. Please make sure you have admin account");
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-center align-items-center vh-100 admin-bg">
        <Card className="card p-3 admin-box"> 
          <h3 className="text-center title">Login As Admin</h3>
          <Card.Body>
            <h6 className="mt-5">Sign In</h6>
            <Form onSubmit={handleSubmit}>
              <Form.Group id="email" className="my-3">
                <InputGroup>
                  <InputGroup.Text className="custom-input">
                    <i className="bi bi-envelope-fill"></i>
                  </InputGroup.Text>
                  <Form.Control
                    className="custom-input"
                    type="email"
                    ref={emailRef}
                    required
                    placeholder="Email *"
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group id="password" className="my-3 ">
                <InputGroup>
                  <InputGroup.Text className="custom-input">
                    <i className="bi bi-lock-fill"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="password"
                    className="custom-input"
                    ref={passwordRef}
                    required
                    placeholder="Password *"
                  />
                </InputGroup>
              </Form.Group>
              {error && <Alert variant="danger mt-2">{error}</Alert>}
              <div>
                <div className="row">
                  <div className="col-6">
                    <Button
                      disabled={loading}
                      type="submit"
                      id="loginBtn"
                      className={` mt-2 ${loading ? "disabled" : ""}`}
                    >
                      LOGIN <i className="bi bi-arrow-right"></i>
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
